function splitIntoSegmentsAndGetMidpoints({ numbers, segmentsCount = 3 }) {
  // Ensure the numbers are sorted
  //remove undefined values
  numbers = numbers.filter(function (element) {
    return element !== undefined;
  });
  numbers.sort((a, b) => a - b);

  // Step 2: Calculate the size of each segment
  const segmentSize = numbers.length / segmentsCount;

  // Step 3: Calculate midpoints for each segment
  const midpoints = [];

  for (let i = 0; i < segmentsCount; i++) {
    const start = i * segmentSize;
    const end = start + segmentSize;
    const midpoint =
      (numbers[Math.floor(start)] + numbers[Math.floor(end) - 1]) / 2;
    midpoints.push(midpoint);
  }

  return midpoints;
}

export default splitIntoSegmentsAndGetMidpoints;
